var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map(p=>{return+p==p?+p:p})},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
const exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
const get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
const eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
const findLatestVersion = (scope, key, eager) => {
	const versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
const findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	const versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
const findSingletonVersionKey = (scope, key, eager) => {
	const versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
const getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
const getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	const versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
const fail = (msg) => {
	throw new Error(msg);
}
const failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
const warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
const init = (fn) => (function(scopeName, key, eager, c, d) {
	const promise = __webpack_require__.I(scopeName);
	if (promise?.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

const useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
const load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
const loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	const satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
const loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	const satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
const loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	const version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
const loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	const version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
const loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	const version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
const installedModules = {};
const moduleToHandlerMapping = {
	4432: () => (loadStrictSingletonVersion("default", "react", false, [4,18,3,1], () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(4159))))))),
	9823: () => (loadStrictSingletonVersion("default", "react-dom", false, [1,18,2,0], () => (__webpack_require__.e(961).then(() => (() => (__webpack_require__(961))))))),
	4466: () => (loadStrictVersion("default", "@emotion/react", false, [1,11,11,4], () => (Promise.all([__webpack_require__.e(9240), __webpack_require__.e(2243)]).then(() => (() => (__webpack_require__(4624))))))),
	653: () => (loadStrictVersion("default", "@emotion/styled", false, [1,11,11,5], () => (__webpack_require__.e(9918).then(() => (() => (__webpack_require__(7537))))))),
	4808: () => (loadStrictVersion("default", "@DeepHealth/dhosdesigntokens", false, [4,0,0,24], () => (__webpack_require__.e(3467).then(() => (() => (__webpack_require__(3467))))))),
	7666: () => (loadStrictVersion("default", "react-router-dom", false, [1,6,22,3], () => (__webpack_require__.e(2648).then(() => (() => (__webpack_require__(2648))))))),
	8034: () => (loadStrictVersion("default", "@mui/material", false, [1,5,15,15], () => (Promise.all([__webpack_require__.e(5463), __webpack_require__.e(4164), __webpack_require__.e(2377)]).then(() => (() => (__webpack_require__(2377))))))),
	4744: () => (loadStrictVersion("default", "uuid", false, [1,11,1,0], () => (__webpack_require__.e(3419).then(() => (() => (__webpack_require__(3419))))))),
	9518: () => (loadSingletonVersion("default", "i18next", false, [1,23,10,1], () => (__webpack_require__.e(2526).then(() => (() => (__webpack_require__(2526))))))),
	1369: () => (loadStrictVersion("default", "react-redux", false, [1,9,2,0], () => (__webpack_require__.e(9073).then(() => (() => (__webpack_require__(9073))))))),
	1415: () => (loadStrictVersion("default", "@reduxjs/toolkit", false, [1,2,8,2], () => (__webpack_require__.e(4319).then(() => (() => (__webpack_require__(4319))))))),
	2023: () => (loadStrictSingletonVersion("default", "@DeepHealth/dhos-common-utils", false, [4,1,0,8], () => (Promise.all([__webpack_require__.e(2380), __webpack_require__.e(6373), __webpack_require__.e(3905)]).then(() => (() => (__webpack_require__(6373))))))),
	2147: () => (loadStrictVersion("default", "redux-persist-indexeddb-storage", false, [1,1,0,4], () => (__webpack_require__.e(2863).then(() => (() => (__webpack_require__(2863))))))),
	2438: () => (loadStrictVersion("default", "js-cookie", false, [1,3,0,5], () => (__webpack_require__.e(5468).then(() => (() => (__webpack_require__(5468))))))),
	3765: () => (loadStrictVersion("default", "zustand", false, [1,4,5,4], () => (__webpack_require__.e(3697).then(() => (() => (__webpack_require__(6078))))))),
	3894: () => (loadSingleton("default", "@DeepHealth/i18n-sdk", false, () => (__webpack_require__.e(7646).then(() => (() => (__webpack_require__(7646))))))),
	4767: () => (loadSingleton("default", "@DeepHealth/component-library", false, () => (Promise.all([__webpack_require__.e(5463), __webpack_require__.e(338)]).then(() => (() => (__webpack_require__(338))))))),
	5011: () => (loadStrictVersion("default", "module-federation-import-remote", false, [1,1,0,24], () => (__webpack_require__.e(8715).then(() => (() => (__webpack_require__(8715))))))),
	5965: () => (loadStrictVersion("default", "axios", false, [4,1,15,2], () => (__webpack_require__.e(8225).then(() => (() => (__webpack_require__(8225))))))),
	6266: () => (loadStrictVersion("default", "styled-components", false, [1,6,1,8], () => (__webpack_require__.e(9598).then(() => (() => (__webpack_require__(9598))))))),
	6540: () => (loadStrictVersion("default", "redux-persist", false, [1,6,0,0], () => (__webpack_require__.e(1385).then(() => (() => (__webpack_require__(1385))))))),
	7806: () => (loadStrictVersion("default", "@tanstack/react-query", false, [1,5,28,14], () => (__webpack_require__.e(8243).then(() => (() => (__webpack_require__(8243))))))),
	9645: () => (loadSingletonVersion("default", "react-i18next", false, [1,14,1,0], () => (__webpack_require__.e(2365).then(() => (() => (__webpack_require__(2365))))))),
	724: () => (loadStrictVersion("default", "@opentelemetry/api", false, [1,1,9,0], () => (__webpack_require__.e(3758).then(() => (() => (__webpack_require__(3758))))))),
	2410: () => (loadStrictVersion("default", "@opentelemetry/semantic-conventions", false, [1,1,25,1], () => (__webpack_require__.e(1506).then(() => (() => (__webpack_require__(1506))))))),
	3558: () => (loadStrictVersion("default", "@opentelemetry/semantic-conventions", false, [1,1,25,1], () => (__webpack_require__.e(9878).then(() => (() => (__webpack_require__(9878))))))),
	5701: () => (loadStrictSingletonVersion("default", "@apollo/client", false, [1,3,11,0], () => (Promise.all([__webpack_require__.e(8657), __webpack_require__.e(4432)]).then(() => (() => (__webpack_require__(8657))))))),
	5733: () => (loadStrictVersion("default", "js-cookie", false, [1,3,0,5], () => (__webpack_require__.e(2899).then(() => (() => (__webpack_require__(2899))))))),
	6769: () => (loadStrictVersion("default", "@opentelemetry/semantic-conventions", false, [1,1,25,1], () => (__webpack_require__.e(6056).then(() => (() => (__webpack_require__(6056))))))),
	9730: () => (loadStrictVersion("default", "axios", false, [4,1,15,2], () => (__webpack_require__.e(1605).then(() => (() => (__webpack_require__(1605)))))))
};
// no consumes in initial chunks
const chunkMapping = {
	"653": [
		653
	],
	"3905": [
		724,
		2410,
		3558,
		5701,
		5733,
		6769,
		9730
	],
	"4347": [
		4808,
		7666,
		8034
	],
	"4432": [
		4432
	],
	"4466": [
		4466
	],
	"4744": [
		4744
	],
	"9177": [
		1369,
		1415,
		2023,
		2147,
		2438,
		3765,
		3894,
		4767,
		5011,
		5965,
		6266,
		6540,
		7806,
		9645
	],
	"9518": [
		9518
	],
	"9823": [
		9823
	]
};
const startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			const onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			const onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				const promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}